/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Позиция (товар/услуга) в счёте на оплату
 */
export interface InvoiceGoodsItem {
  /**
   * Идентификатор позиции
   * @format uuid
   * @example 11371697-e352-4cee-aee8-0520405a284d
   */
  id?: string;

  /**
   * Идентификатор товара/услуги в позиции
   * @format uuid
   * @example 3345901d-5b21-4977-a8bb-38ac4dd3736d
   */
  goodsId?: string;

  /**
   * Наименование товара/услуги в позиции
   * @example Трактор Т-150
   */
  name: string;

  /**
   * Описание товара/услуги в позиции
   * @example Трактор марки Т-150 в комплекте
   */
  desc?: string;

  /**
   * Количество товаров/услуг в позиции
   * @example 2
   */
  quantity: number;

  /**
   * Единица измерения товара/услуги в позиции
   * @example шт
   */
  unit: string;

  /**
   * Идентификатор единицы измерения товара/услуги в позиции
   * @format uuid
   * @example f7b7f955-1761-4014-bf62-86ff281c0b30
   */
  unitId?: string;

  /**
   * Цена товара/услуги в позиции
   * @example 15000000
   */
  price: number;

  /**
   * Сумма в позиции
   * @example 30000000
   */
  amount?: number;

  /**
   * Номер п/п позиции
   * @format int32
   * @example 1
   */
  number?: number;

  /**
   * Ставка НДС в позиции
   * @format int32
   * @example 18
   */
  taxRate?: number;

  /**
   * Признак редактирования справочников для позиции в счёте на оплату
   * @example true
   */
  isEdit?: boolean;
}

/**
 * Плательщик
 */
export interface InvoicePayer {
  /**
   * Идентификатор плательщика
   * @format uuid
   * @example e3babf08-2b73-4221-a4c7-f3ccda635266
   */
  id?: string;

  /**
   * Наименование плательщика
   * @example ООО "Ромашка"
   */
  name: string;

  /**
   * ИНН плательщика
   * @example 5075101010
   */
  inn: string;

  /**
   * КПП плательщика
   * @example 507501001
   */
  kpp?: string;

  /**
   * Адрес плательщика
   * @example Москва, пл. Красная, д. 1
   */
  address?: string;

  /**
   * Номер договора с плательщиком
   * @example 10
   */
  agreementNumber?: string;

  /**
   * Дата договора с плательщиком
   * @format date
   * @example 2020-12-22
   */
  agreementDate?: string;

  /**
   * Признак редактирования плательщика в справочнике
   * @example false
   */
  isEdit?: boolean;

  /** Список подписантов плательщика */
  signers?: InvoiceSigner[];
}

/**
 * Запрос на создание счёта на оплату
 */
export interface InvoiceRequest {
  /**
   * Номер счёта на оплату
   * @example 10
   */
  number: string;

  /**
   * Игнорировать валидаторы в режиме WARNING
   * @example true
   */
  ignoreWarning: boolean;

  /**
   * Дата счёта на оплату
   * @format date
   * @example 2022-10-20
   */
  date: string;

  /** Список позиций в счёте на оплату */
  goodsList: InvoiceGoodsItem[];

  /**
   * Общая сумма по счёту на оплату
   * @example 12345.67
   */
  amount?: number;

  /**
   * Ставка НДС для счёта на оплату
   * @format int32
   * @example 18
   */
  taxRate?: number;

  /**
   * Номер расчётного счёта получателя
   * @example 40702810135090000183
   */
  receiverAccountNumber: string;

  /** Плательщик */
  payer: InvoicePayer;

  /** Список подписантов по счёту на оплату */
  signers: InvoiceSigner[];
}

/**
 * Подписант
 */
export interface InvoiceSigner {
  /**
   * Идентификатор подписанта
   * @format uuid
   * @example 2ef4d583-67b7-466d-99ce-5120b8b775de
   */
  id?: string;

  /**
   * ФИО подписанта
   * @example Иванов И.И.
   */
  name: string;

  /**
   * Должность подписанта
   * @example генеральный директор
   */
  position?: string;
}

/**
 * Ответ на запрос на создание счёта на оплату
 */
export interface InvoiceResponse {
  /**
   * Идентификатор счёта на оплату
   * @format uuid
   * @example 80db1f34-deab-4db4-ba33-4c9a726178ba
   */
  id: string;

  /**
   * Номер счёта на оплату
   * @example 10
   */
  number: string;

  /**
   * Статус счёта на оплату
   * @example NEW
   */
  state: string;
}

/**
 * Ошибка валидации
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Сообщение об ошибкe валидации
 */
export interface ValidationErrorItem {
  /** Сообщение об ошибке */
  message?: string;

  /** Поля, содержащие ошибку */
  fields?: string[];
}

/**
 * Сообщение об ошибках валидации
 */
export interface ValidationErrorMessage {
  /** Ошибки валидации */
  errors?: ValidationErrorItem[];

  /** Предупреждения валидации */
  warnings?: ValidationErrorItem[];

  /** Дата и время возникновения ошибок валидации */
  timestamp?: string;
}

export type EmptyResponse = object;

/**
 * Запрос на сохранение платёжного поручения, связанного со счётом на оплату
 */
export interface InvoicePaymentRequest {
  /**
   * Идентификатор платёжного поручения
   * @format uuid
   * @example d281cb9c-b003-48a7-af10-b6ddf9fe0c77
   */
  paymentId: string;
}

/**
 * Запрос на отправку счёта на оплату по электронной почте
 */
export interface InvoiceEmailRequest {
  /**
   * Адрес электронной почты для отправки счёта на оплату
   * @example ivanov@firma.ru
   */
  email: string;

  /**
   * Приложить все печатные формы документов по счёту на оплату
   * @example true
   */
  withDocuments?: boolean;
}

/**
 * Тип отчётного документа по счёту на оплату
 * @example ACT
 */
export enum DocType {
  ACT = "ACT",
  WAYBILL = "WAYBILL",
  TAX_INVOICE = "TAX_INVOICE",
}

/**
 * Запрос на создание печатных форм отчётных документов в счёте на оплату
 */
export interface InvoiceDocumentsPrintRequest {
  /** Запросы на создание печатных форм отдельных документов */
  documents: InvokePrintRequest[];
}

/**
 * Запрос на создание печатной формы отчётного документа в счёте на оплату
 */
export interface InvokePrintRequest {
  /** Тип отчётного документа по счёту на оплату */
  templateType: DocType;

  /**
   * Номер документа
   * @example 5
   */
  number: string;

  /**
   * Дата документа
   * @format date
   * @example 2022-10-20
   */
  date: string;

  /** Список идентификаторов позиций из счёта на оплату */
  goods: string[];

  /**
   * Текст перед таблицей в печатной форме
   * @example Внимание! Оплатить до ___
   */
  textBefore?: string;

  /**
   * Текст после таблицы в печатной форме
   * @example Примечание. Действителен до ___
   */
  textAfter?: string;

  /** Список подписантов в документе */
  signers: InvoiceSigner[];
}

/**
 * Отчётный документ по счёту на оплату
 */
export interface InvoiceDocument {
  /**
   * Идентификатор документа
   * @format uuid
   * @example 69b3255f-42e5-4f4a-b7ba-9699ea3f064f
   */
  id: string;

  /**
   * Номер документа
   * @example 5
   */
  number: string;

  /**
   * Дата документа
   * @format date
   * @example 2022-10-20
   */
  date: string;

  /**
   * Наименование документа
   * @example Акт выполненных работ
   */
  name: string;

  /** Тип отчётного документа по счёту на оплату */
  docType: DocType;

  /**
   * Документ прочитан плательщиком
   * @example true
   */
  receiverRead: boolean;

  /**
   * Документ отправлен плательщику
   * @example true
   */
  receiverSent: boolean;
}

/**
 * Список отчётных документов по счёту на оплату
 */
export interface InvoiceDocuments {
  /** Отчётные документы по счёту на оплату */
  documents: InvoiceDocument[];
}

/**
 * Запрос на отправку печатной формы отчётного документа в счёте на оплату по электронной почте
 */
export interface InvoiceDocumentEmailRequest {
  /**
   * Адрес электронной почты для отправки печатной формы отчётного документа
   * @example ivanov@firma.ru
   */
  email: string;
}

/**
 * Направление счёта оплату
 * @example OUTGOING
 */
export enum Direction {
  OUTGOING = "OUTGOING",
  INCOMING = "INCOMING",
}

/**
 * Краткая информация о счёте на оплату
 */
export interface InvoiceShort {
  /**
   * Идентификатор счёта на оплату
   * @format uuid
   * @example ab2d2a36-3040-452e-85a4-0fc075a52bce
   */
  id: string;

  /**
   * Дата счёта на оплату
   * @format date
   * @example 2022-10-20
   */
  date: string;

  /**
   * Номер счёта на оплату
   * @example 10
   */
  number: string;

  /**
   * Идентификатор платёжного поручения, связанного со счётом на оплату
   * @format uuid
   * @example faaa1805-e291-4322-a75c-21ae315082ec
   */
  paymentId?: string;

  /**
   * Общая сумма по счёту на оплату
   * @example 12345.67
   */
  amount: number;

  /**
   * Статус счёта на оплату
   * @example NEW
   */
  state: string;

  /** Направление счёта оплату */
  direction: Direction;

  /**
   * Наименование плательщика по счёту на оплату
   * @example ООО Ромашка
   */
  payerName: string;

  /**
   * ИНН плательщика по счёту на оплату
   * @example 5051525354
   */
  payerInn?: string;

  /**
   * Наименование получателя по счёту на оплату
   * @example ПАО Лютик
   */
  receiverName: string;

  /**
   * Номер расчётного счёта получателя по счёту на оплату
   * @example 40204021402240234024
   */
  receiverAccountNumber: string;

  /**
   * ИНН получателя по счёту на оплату
   * @example 7071727374
   */
  receiverInn?: string;

  /**
   * Новое уведомление по счёту на оплату
   * @example true
   */
  hasNewNotification?: boolean;

  /**
   * Количество закрывающих документов по счёту на оплату
   * @format int32
   * @example 3
   */
  countClosingDocuments?: number;

  /** Разрешения пользователя для счёта на оплату */
  permissions: Permissions;
}

/**
 * Список счетов на оплату
 */
export interface InvoicesInfoResponse {
  /** Список плательщиков */
  invoices: InvoiceShort[];

  /**
   * Возможна дальнейшая постраничная подгрузка
   * @example true
   */
  hasMore: boolean;
}

/**
 * Разрешения пользователя для счёта на оплату
 */
export interface Permissions {
  /**
   * Разрешение на редактирование
   * @example true
   */
  canEdit: boolean;

  /**
   * Разрешение на удаление
   * @example true
   */
  canDelete: boolean;

  /**
   * Разрешение на печать
   * @example true
   */
  canPrint: boolean;

  /**
   * Разрешение на выставление плательщику
   * @example true
   */
  canSend: boolean;

  /**
   * Разрешение на отправку по электронной почте
   * @example true
   */
  canEmail: boolean;

  /**
   * Разрешение на скрытие
   * @example true
   */
  canHide: boolean;

  /**
   * Разрешение на отметку оплаченным
   * @example true
   */
  canMarkPaid: boolean;

  /**
   * Разрешение на оплату счёта
   * @example true
   */
  canPay: boolean;
}

/**
 * Реквизиты банка получателя
 */
export interface Bank {
  /**
   * Наименование банка
   * @example ПАО "Россельхозбанк"
   */
  name: string;

  /**
   * Тип населённого пункта местонахождения банка
   * @example г.
   */
  placetype: string;

  /**
   * Наименование населённого пункта местонахождения банка
   * @example Москва
   */
  placename: string;

  /**
   * БИК банка
   * @example 045056078
   */
  bic: string;

  /**
   * Номер корр. счёта банка
   * @example 30101010101010101010
   */
  corAccount: string;
}

/**
 * Информация о счёте на оплату
 */
export interface InvoiceInfoResponse {
  /**
   * Идентификатор счёта на оплату
   * @format uuid
   * @example a3577f76-738f-43e6-940f-79a914cf945b
   */
  id: string;

  /**
   * Дата счёта на оплату
   * @format date
   * @example 2022-10-20
   */
  date: string;

  /**
   * Номер счёта на оплату
   * @example 10
   */
  number: string;

  /**
   * Идентификатор платёжного поручения, связанного со счётом на оплату
   * @format uuid
   * @example 3b2db4d0-8c52-49cd-bd7a-f1e3084d4f31
   */
  paymentId?: string;

  /**
   * Общая сумма по счёту на оплату
   * @example 12345.67
   */
  amount: number;

  /**
   * Общая сумма НДС по счёту на оплату
   * @example 123.45
   */
  tax: number;

  /** Суммы НДС по ставкам НДС в счёте на оплату */
  taxes: Tax[];

  /** Список позиций в счёте на оплату */
  goodsList: InvoiceGoodsItem[];

  /** Плательщик */
  payer: InvoicePayer;

  /** Получатель */
  receiver: InvoiceReceiver;

  /** Список подписантов по счёту на оплату */
  signers: InvoiceSigner[];

  /**
   * Статус счёта на оплату
   * @example NEW
   */
  state: string;

  /** Направление счёта оплату */
  direction: Direction;

  /** Разрешения пользователя для счёта на оплату */
  permissions: Permissions;
}

/**
 * Получатель
 */
export interface InvoiceReceiver {
  /**
   * Наименование получателя
   * @example ООО "Ромашка"
   */
  name: string;

  /**
   * ИНН получателя
   * @example 5075101010
   */
  inn: string;

  /**
   * КПП получателя
   * @example 507501001
   */
  kpp?: string;

  /**
   * Идентификатор расчётного счёта получателя
   * @format uuid
   * @example 0eb604d1-e61e-4278-abae-017ed6031501
   */
  account?: string;

  /**
   * Номер расчётного счёта получателя
   * @example 40702810135090000183
   */
  accountNumber: string;

  /** Реквизиты банка получателя */
  bank: Bank;
}

/**
 * Сумма НДС по ставке в счёте оплату
 */
export interface Tax {
  /**
   * Ставка НДС
   * @format int32
   * @example 15
   */
  taxRate: number;

  /**
   * Сумма НДС
   * @example 123.45
   */
  tax: number;
}

/**
 * Единица измерения товаров и услуг
 */
export interface InvoiceUnit {
  /**
   * Идентификатор единицы измерения
   * @format uuid
   * @example 2d97db09-0d92-4118-b673-51c9c614246d
   */
  id: string;

  /**
   * Код единицы измерения
   * @example 355
   */
  code?: string;

  /**
   * Наименование единицы измерения
   * @example мин
   */
  name: string;

  /**
   * Описание единицы измерения
   * @example Минута
   */
  desc?: string;

  /**
   * Принадлежность единицы измерения справочнику ОКЕИ
   * @example true
   */
  standard: boolean;
}

/**
 * Единицы измерения товаров и услуг
 */
export interface InvoiceUnits {
  /** Список единиц измерения */
  units: InvoiceUnit[];
}

/**
 * Плательщики
 */
export interface InvoicePayersResponse {
  /** Список плательщиков */
  data: InvoicePayer[];

  /**
   * Возможна дальнейшая постраничная подгрузка
   * @example true
   */
  hasMore: boolean;
}

/**
 * Очередной номер для счёта на оплату
 */
export interface DocumentNumberResponse {
  /**
   * Номер
   * @example 10
   */
  number: string;
}

/**
 * Количество непрочитанных входящих счетов на оплату
 */
export interface InvoicesIncomingDocumentWithNotification {
  /**
   * Количество счетов на оплату
   * @format int32
   * @example 5
   */
  documentCount: number;
}

/**
 * Информация по товару/услуге
 */
export interface InvoiceGoodShort {
  /**
   * Идентификатор товара/услуги
   * @format uuid
   * @example 239c6e2f-e8d8-4e5f-9e17-878ad402a588
   */
  id: string;

  /**
   * Наименование товара/услуги
   * @example Трактор Т-150
   */
  name: string;

  /**
   * Единица измерения товара/услуги
   * @example шт
   */
  unit?: string;

  /**
   * Идентификатор единицы измерения товара/услуги
   * @format uuid
   * @example fc374108-3930-443b-b9cc-102bd3e96e97
   */
  unitId?: string;

  /**
   * Код единицы измерения товара/услуги
   * @example 796
   */
  unitCode?: string;

  /**
   * Цена товара/услуги
   * @example 15000000
   */
  price?: number;

  /**
   * Ставка НДС для товара/услуги
   * @format int32
   * @example 18
   */
  taxRate?: number;
}

/**
 * Товары и услуги
 */
export interface InvoiceGoodsShort {
  /** Список товаров/услуг */
  goods: InvoiceGoodShort[];

  /**
   * Возможна дальнейшая постраничная подгрузка
   * @example true
   */
  hasMore: boolean;
}

/**
 * Расчётный счёт клиента
 */
export interface Account {
  /**
   * Идентификатор расчётного счёта
   * @format uuid
   * @example 880df9ce-7039-499a-94f5-74951560f644
   */
  id?: string;

  /**
   * Наименование расчётного счёта
   * @example расчетный
   */
  name?: string;

  /**
   * ФИО подопечного по расчётному счёту
   * @example Иванов Петр Семёнович
   */
  wardName?: string;

  /**
   * Номер расчётного счёта
   * @example 40104020403040404050
   */
  number?: string;

  /**
   * Буквенный ISO-код валюты расчётного счёта
   * @example RUR
   */
  currency?: string;

  /**
   * Текущий остаток по расчётному счёту
   * @example 1234567.89
   */
  currentBalance?: number;
}

export interface GetInvoicesParams {
  /** @format int32 */
  position?: number;

  /** @format int32 */
  size?: number;
  searchText?: string;
  stateList?: string[];

  /** Направление счёта оплату */
  direction: "OUTGOING" | "INCOMING";

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  hasNewNotification?: boolean;
}

export interface PrintInvoiceParams {
  withoutDocuments?: boolean;

  /** @format uuid */
  invoiceId: string;
}

export interface GetGoodsUnitsParams {
  searchText?: string;
}

export interface GetPayersParams {
  /** @format int32 */
  position?: number;

  /** @format int32 */
  size?: number;
  searchText?: string;
  inn?: string;
}

export interface GetGoodsParams {
  /** @format int32 */
  position?: number;

  /** @format int32 */
  size?: number;
  searchText?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-invoices
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://localhost:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Счета на оплату <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=44486754)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetInvoice
     * @summary Получение информации о счёте на оплату
     * @request GET:/api/invoices/v1/external/invoices/{invoiceId}
     * @secure
     */
    getInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.request<InvoiceInfoResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name EditInvoice
     * @summary Редактирование счёта на оплату
     * @request PUT:/api/invoices/v1/external/invoices/{invoiceId}
     * @secure
     */
    editInvoice: (
      invoiceId: string,
      data: InvoiceRequest,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceResponse, ErrorMessage | ValidationErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name DeleteInvoice
     * @summary Удаление счёта на оплату
     * @request DELETE:/api/invoices/v1/external/invoices/{invoiceId}
     * @secure
     */
    deleteInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name MarkInvoice
     * @summary Отметка счёта на оплату оплаченным
     * @request PUT:/api/invoices/v1/external/invoices/{invoiceId}/pay
     * @secure
     */
    markInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/pay`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name HideInvoice
     * @summary Скрытие счёта на оплату из списка входящих
     * @request PUT:/api/invoices/v1/external/invoices/{invoiceId}/hide
     * @secure
     */
    hideInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/hide`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetInvoices
     * @summary Получение списка счетов на оплату
     * @request GET:/api/invoices/v1/external/invoices
     * @secure
     */
    getInvoices: (query: GetInvoicesParams, params: RequestParams = {}) =>
      this.request<InvoicesInfoResponse, ErrorMessage | ValidationErrorMessage>(
        {
          path: `/api/invoices/v1/external/invoices`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name CreateInvoice
     * @summary Создание счёта на оплату
     * @request POST:/api/invoices/v1/external/invoices
     * @secure
     */
    createInvoice: (data: InvoiceRequest, params: RequestParams = {}) =>
      this.request<InvoiceResponse, ErrorMessage | ValidationErrorMessage>({
        path: `/api/invoices/v1/external/invoices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name SendInvoice
     * @summary Отправка счёта на оплату через ДБО
     * @request POST:/api/invoices/v1/external/invoices/{invoiceId}/send
     * @secure
     */
    sendInvoice: (invoiceId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/send`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name SaveInvoicePayment
     * @summary Сохранение платёжного поручения, связанного со счётом на оплату
     * @request POST:/api/invoices/v1/external/invoices/{invoiceId}/payment
     * @secure
     */
    saveInvoicePayment: (
      invoiceId: string,
      data: InvoicePaymentRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/payment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name EmailInvoice
     * @summary Отправка счёта на оплату по электронной почте
     * @request POST:/api/invoices/v1/external/invoices/{invoiceId}/email
     * @secure
     */
    emailInvoice: (
      invoiceId: string,
      data: InvoiceEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/email`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчётные документы в счетах на оплату
     * @name GetDocuments
     * @summary Получение списка отчётных документов в счёте на оплату
     * @request GET:/api/invoices/v1/external/invoices/{invoiceId}/documents
     * @secure
     */
    getDocuments: (invoiceId: string, params: RequestParams = {}) =>
      this.request<InvoiceDocuments, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/documents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчётные документы в счетах на оплату
     * @name CreateDocuments
     * @summary Создание печатных форм отчётных документов в счёте на оплату
     * @request POST:/api/invoices/v1/external/invoices/{invoiceId}/documents
     * @secure
     */
    createDocuments: (
      invoiceId: string,
      data: InvoiceDocumentsPrintRequest,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceDocuments, ErrorMessage | ValidationErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/documents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчётные документы в счетах на оплату
     * @name EmailDocument
     * @summary Отправка печатной формы отчётного документа в счёте на оплату по электронной почте
     * @request POST:/api/invoices/v1/external/invoices/{invoiceId}/documents/{documentId}/email
     * @secure
     */
    emailDocument: (
      invoiceId: string,
      documentId: string,
      data: InvoiceDocumentEmailRequest,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/documents/${documentId}/email`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name PrintInvoice
     * @summary Получение печатной формы счёта на оплату
     * @request GET:/api/invoices/v1/external/invoices/{invoiceId}/print
     * @secure
     */
    printInvoice: (
      { invoiceId, ...query }: PrintInvoiceParams,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/print`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчётные документы в счетах на оплату
     * @name GetDocument
     * @summary Получение печатной формы отчётного документа в счёте на оплату
     * @request GET:/api/invoices/v1/external/invoices/{invoiceId}/documents/{documentId}/print
     * @secure
     */
    getDocument: (
      invoiceId: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/documents/${documentId}/print`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetGoodsUnits
     * @summary Получение списка единиц измерения товаров/услуг
     * @request GET:/api/invoices/v1/external/invoices/units
     * @secure
     */
    getGoodsUnits: (query: GetGoodsUnitsParams, params: RequestParams = {}) =>
      this.request<InvoiceUnits, ErrorMessage | ValidationErrorMessage>({
        path: `/api/invoices/v1/external/invoices/units`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetPayers
     * @summary Получение списка плательщиков
     * @request GET:/api/invoices/v1/external/invoices/payers
     * @secure
     */
    getPayers: (query: GetPayersParams, params: RequestParams = {}) =>
      this.request<
        InvoicePayersResponse,
        ErrorMessage | ValidationErrorMessage
      >({
        path: `/api/invoices/v1/external/invoices/payers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetNumber
     * @summary Получение очередного номера для счёта на оплату
     * @request GET:/api/invoices/v1/external/invoices/number
     * @secure
     */
    getNumber: (params: RequestParams = {}) =>
      this.request<DocumentNumberResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/number`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetNotificationCount
     * @summary Получение количества непрочитанных входящих счетов на оплату
     * @request GET:/api/invoices/v1/external/invoices/notification/count
     * @secure
     */
    getNotificationCount: (params: RequestParams = {}) =>
      this.request<InvoicesIncomingDocumentWithNotification, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/notification/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета на оплату
     * @name GetGoods
     * @summary Получение списка товаров/услуг
     * @request GET:/api/invoices/v1/external/invoices/goods
     * @secure
     */
    getGoods: (query: GetGoodsParams, params: RequestParams = {}) =>
      this.request<InvoiceGoodsShort, ErrorMessage | ValidationErrorMessage>({
        path: `/api/invoices/v1/external/invoices/goods`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочные данные
     * @name GetAccounts
     * @summary Получение расчётных счетов клиента
     * @request GET:/api/invoices/v1/external/dict/account
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/invoices/v1/external/dict/account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчётные документы в счетах на оплату
     * @name DeleteDocument
     * @summary Удаление отчётного документа в счёте на оплату
     * @request DELETE:/api/invoices/v1/external/invoices/{invoiceId}/documents/{documentId}
     * @secure
     */
    deleteDocument: (
      invoiceId: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/invoices/v1/external/invoices/${invoiceId}/documents/${documentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
